import { Component, inject, viewChild, OnInit } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { BasicDialogComponent } from '../../../../shared/components/basic-dialog/basic-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../services/user/user.service';
import { IProfile } from '../../../../models';

@Component({
  selector: 'app-toolbar',
  imports: [
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {
  readonly menuTrigger = viewChild.required(MatMenuTrigger);
  readonly dialog = inject(MatDialog);
  readonly router = inject(Router);

  user: IProfile | null = null;

  constructor(private _userService: UserService) {}

  ngOnInit(): void {
    this.getUser();
  }

  // User profile image URL (you can change this to the real one)
  userProfileImage =
    'https://via.placeholder.com/48x48/cccccc/666666?text=User';

  openDialog() {
    const dialogRef = this.dialog.open(BasicDialogComponent);
    dialogRef.afterClosed().subscribe(() => console.log('Dialog closed'));
  }

  navigateToAdmin(): void {
    if (this.user?.userType == 'admin') {
      this.router.navigate(['/admin']);
    }
  }

  async getUser() {
    try {
      this.user = await this._userService.fecthUser();
    } catch (error) {
      console.log(error);
    }
  }

  getPictureURL(): string {
    if (this.user) {
      return `https://adhoc.rd.astrazeneca.net/api/thumbs/${this.user.pridId}?appid=rdpo`;
    } else {
      // avoid show an empty space if the profile is still loading
      return '/assets/img/default_user_picture.jpeg';
    }
  }
}
